import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter, Inject,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges, ViewChild
} from "@angular/core";
import * as _ from "lodash";
import {CdkDragDrop} from "@angular/cdk/drag-drop";
import {CdkVirtualScrollViewport} from "@angular/cdk/scrolling";
import {VisitPlanRouteModel} from "../../../models/visit-plan-route.model";

require('./visit-plan-routes-panel-list.scss');
@Component({
  standalone: false,
  selector: 'app-visit-plan-routes-panel-list',
  templateUrl: './visit-plan-routes-panel-list.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VisitPlanRoutesPanelListComponent implements OnInit, OnChanges {

  @Input() routes: VisitPlanRouteModel[];
  @Input() isLoadingRoutes: boolean;
  @Input() panel: any;
  @Input() panels: any[];
  @Input() jobs: any[];
  @Input() selectedIds: string[];
  @Input() selectedJobIds: string[];
  @Input() agentColorMap: { [key: string]: string };
  @Input() visibleIds: string[];
  @Input() settings: any;
  @Input() itemElementSize: string;
  @Output() onSelectRoutes = new EventEmitter<string[]>();
  @Output() onSelect = new EventEmitter<any>();
  @Output() onVisibleRoutesChange = new EventEmitter<string[]>();
  @Output() onLockRouteChange = new EventEmitter<{ id: string, locked: boolean }>();
  @Output() onChangeRouteResource = new EventEmitter<{any}>();
  @Output() onEditResourceAllocation = new EventEmitter<{ route: any, event: any }>();
  @Output() onMoveJobs = new EventEmitter();
  @Output() onDrillDown = new EventEmitter<{ routeId: string, event: any }>();
  @Output() onFetchNext = new EventEmitter<null>();
  @Output() onRoutePanelContextMenu = new EventEmitter<{ routeId: string, event: any }>();

  @ViewChild(CdkVirtualScrollViewport, {static: false})
  private cdkVirtualScrollViewport: CdkVirtualScrollViewport;

  public connectedPanelIds: string[];
  public selectedKeys: Object;
  public visibleKeys: Object;
  // public hoveredRouteId?: string;
  public dropAnimations: Array<{
    x: number,
    y: number,
    text: string,
    id: number,
    isMultiple: boolean,
    count: number
  }> = [];


  constructor(
    @Inject('planningAlertsService') private planningAlertsService,
    @Inject('$timeout') private $timeout,
    @Inject(ChangeDetectorRef) private cdr: ChangeDetectorRef) {

  }

  ngOnInit() {

  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.panels) {
      const filteredPanels = _.filter(this.panels, (p) => {
        return p.id !== this.panel.id;
      })
      this.connectedPanelIds = _.map(filteredPanels, 'id');
    }
    if (changes.selectedIds) {
      this.selectedKeys = {};
      _.forEach(this.selectedIds, (id) => {
        this.selectedKeys[id] = true;
      });
    }
    if (changes.visibleIds) {
      this.visibleKeys = {};
      _.forEach(this.visibleIds, (id) => {
        this.visibleKeys[id] = true;
      });
    }
  }

  onScroll(event: Event): void {
    window.dispatchEvent(new Event('resize'));
  }

  onToggleSelectedRoute(id, isSelected: boolean) {
    this.selectedKeys[id] = isSelected;
    const selectedIds = _.map(this.selectedKeys, (value, key) => {
      if (value) return key;
    });

    this.onSelectRoutes.emit(_.compact(selectedIds));
  }

  onToggleVisibleRoute(id, isVisible: boolean) {
    this.visibleKeys[id] = isVisible;
    const visibleIds = _.map(this.visibleKeys, (value, key) => {
      if (value) return key;
    });

    this.onVisibleRoutesChange.emit(_.compact(visibleIds));
  }

  trackById(service: any): number {
    return service.id;
  }

  // onDropEnter(routeId: string) {
  //   this.hoveredRouteId = routeId;
  // }
  //
  // onDropExit(routeId: string) {
  //   if (this.hoveredRouteId === routeId) {
  //     this.hoveredRouteId = null;
  //   }
  // }

  onDrop(route: any, event: CdkDragDrop<string[]>) {
    if (!event.isPointerOverContainer) {
      return false;
    }

    // const isJob = !!_.get(event.item.data, 'jobType');
    // const isActivity = !!_.get(event.item.data, 'stopType');
    // const jobId = isJob ? _.get(event.item.data, 'id') : _.get(event.item.data, 'jobId');
    // const jobIds = _.get(event.item.data, 'jobIds');
    //
    // if ((!jobId && !jobIds) || (!isJob && !isActivity)) {
    //   return false;
    // }
    //
    // // Get drop position and determine if multiple items
    // const rect = event.container.element.nativeElement.getBoundingClientRect();
    // const x = rect.left + rect.width / 2;
    // const y = rect.top + rect.height / 2;
    //
    // // Check if multiple items are being dropped
    // const isMultipleDrop = !!jobIds || (this.selectedJobIds?.length > 1 && _.includes(this.selectedJobIds, jobId));
    // const dropCount = jobIds ? jobIds.length : (this.selectedJobIds?.length || 1);
    //
    // // Show animation after drop with appropriate styling
    // this.$timeout(() => {
    //   this.showDropAnimation(x, y, dropCount, isMultipleDrop);
    // }, 50); // Small delay to ensure drop completes first
    //
    //
    // if (!!jobIds || (this.selectedJobIds?.length && _.includes(this.selectedJobIds, jobId))) {
    //   const jobIdsToMove = jobIds || this.selectedJobIds;
    //   return this._dropJobs(route, jobIdsToMove);
    // } else {
    //   let job
    //   if (isActivity) {
    //     job = _.find(this.jobs, (j) => {
    //       return j.id === event.item.data.jobId
    //     })
    //   } else if (isJob) {
    //     job = event.item.data;
    //   }
    //   return this._dropJob(route, job);
    // }
  }

  // private _dropJobs(route: any, jobIds: string[]) {
  //   const jobsToAdd = [];
  //
  //   jobIds.forEach((id) => {
  //     const job = this.jobs.find((j) => {
  //       return j.id === id;
  //     })
  //     if (!!job) {
  //       jobsToAdd.push(job);
  //     }
  //   })
  //
  //   let jobIdsToMove = [];
  //   let stopIds = [];
  //   jobsToAdd.forEach((j) => {
  //     const canAdd = this._canJobAddToRoute(j, route);
  //     if (!!canAdd) {
  //       jobIdsToMove.push(j.id);
  //       stopIds = stopIds.concat(_.map(_.get(j, 'stops') || [], 'id'));
  //     }
  //   })
  //
  //   if (!jobIdsToMove.length) {
  //     return false;
  //   }
  //
  //   const payload = {
  //     jobIds: jobIdsToMove,
  //     toRouteId: route.id,
  //     // fromOrderedIds: this._getStopsOrderIds(event.previousContainer.data),
  //     toOrderedIds: _.concat(this._getStopsOrderIds(route.activities), stopIds)
  //   }
  //   this.onMoveJobs.emit(payload);
  //   return false;
  // }

  // private _dropJob(route: any, job) {
  //   const jobId = _.get(job, 'id');
  //   const jobType = _.get(job, 'jobType');
  //   const fromRouteId = _.get(job, 'routeId')
  //
  //   const canAdd = this._canJobAddToRoute(job, route);
  //   if (!canAdd) {
  //     return false;
  //   }
  //
  //   const stopIds = _.map(_.get(job, 'stops') || [], 'id');
  //   const payload = {
  //     jobIds: [jobId],
  //     fromRouteId: fromRouteId,
  //     toRouteId: route.id,
  //     // fromOrderedIds: this._getStopsOrderIds(event.previousContainer.data),
  //     toOrderedIds: _.concat(this._getStopsOrderIds(route.activities), stopIds)
  //   }
  //   this.onMoveJobs.emit(payload);
  //
  //   return false;
  // }

  // private _canJobAddToRoute(job, route) {
  //
  //   // Already In Route
  //   if (_.includes(route.jobIds, job.id)) {
  //     this.planningAlertsService.alreadyInRouteInfo();
  //     return false;
  //   }
  //
  //   // Route Is Locked
  //   if (!!route.locked) {
  //     this.planningAlertsService.routeIsLocked();
  //     return false;
  //   }
  //
  //   // Route Is Dispatched
  //   if (route.status === 'DISPATCHED') {
  //     this.planningAlertsService.routeIsDispatchedInfo();
  //     return false;
  //   }
  //
  //   // Skills Match
  //   const jobSkills = _.get(job, 'skills', (job.jobType === 'Operation' ? ['Merchandise'] : ['Delivery']))
  //   const resourceSkills = _.get(route, 'resource.allocationSkills', []);
  //   const hasMatchingSkills = !_.difference(jobSkills, resourceSkills).length;
  //
  //   if (!hasMatchingSkills) {
  //     this.planningAlertsService.noMatchingSkillsInfo();
  //     return false;
  //   }
  //
  //   return true;
  //
  //   // if (!_.includes(resourceSkills, leftoverSkill)) {
  //   //   const stopType = this.$filter('translate')('SKILLS.' + leftoverSkill);
  //   //   const routeType = this.$filter('translate')('SKILLS.' + resourceSkills[0]);
  //   //   this.planningAlertsService.stopTypeToRouteRejectionInfo(stopType, routeType);
  //   //   canAddBulk = false;
  //   //   return false;
  //   // }
  // }
  //
  // private _getStopsOrderIds(activities) {
  //   return _.chain(activities)
  //     .filter((a: any) => {
  //       return _.isEqual(a.type, 'STOP') || _.isEqual(a.type, 'GROUP');
  //     })
  //     .map((filteredItem: any) => {
  //       return filteredItem.stopId || filteredItem.stopIds;
  //     })
  //     .flatten()
  //     .value()
  // }
  //
  // private showDropAnimation(x: number, y: number, count: number, isMultiple: boolean): void {
  //   const animationId = Date.now();
  //
  //   this.dropAnimations.push({
  //     x: x,
  //     y: y,
  //     text: isMultiple ? `${count} Jobs` : 'Job',
  //     id: animationId,
  //     isMultiple: isMultiple,
  //     count: count
  //   });
  //
  //   this.cdr.detectChanges();
  //
  //   this.$timeout(() => {
  //     this.dropAnimations = this.dropAnimations.filter(a => a.id !== animationId);
  //     this.cdr.detectChanges();
  //   }, 600);
  // }

}
